"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _SVGIcon = _interopRequireDefault(require("./SVGIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const MenuItems = _styledComponents.default.div.withConfig({
  displayName: "ActionsMenu__MenuItems",
  componentId: "sc-5ewbei-0"
})([" ", ""], p => (0, _styledComponents.css)(["display:", ";position:absolute;z-index:1001;top:", "px;left:", "px;border-radius:4px;box-shadow:2px 2px 6px 0 rgba(0,0,0,0.4);background:#fff;color:#2e2f32;font-size:14px;width:", "px;right:0;padding:8px 0;"], p.show ? 'block' : 'none', p.top, p.left, p.width));

const Item = _styledComponents.default.div.withConfig({
  displayName: "ActionsMenu__Item",
  componentId: "sc-5ewbei-1"
})([" ", ""], p => (0, _styledComponents.css)(["display:flex;align-items:center;padding:0 16px;height:32px;cursor:pointer;", ";&:hover{background:#f1f1f1;}", ";", ";"], p.theme.transition, p => p.color && (0, _styledComponents.css)(["color:", ";svg path{fill:", " !important;}"], p.color, p.color), p => p.disabled && (0, _styledComponents.css)(["cursor:default;color:#aaa;&:hover{background:#fff;}"])));

const Background = _styledComponents.default.div.withConfig({
  displayName: "ActionsMenu__Background",
  componentId: "sc-5ewbei-2"
})(["position:fixed;z-index:1000;top:0;left:0;width:100%;height:100%;background:#88888822;"]);

const StyledIcon = (0, _styledComponents.default)(_SVGIcon.default).withConfig({
  displayName: "ActionsMenu__StyledIcon",
  componentId: "sc-5ewbei-3"
})([" ", ""], p => (0, _styledComponents.css)(["svg path{fill:", ";}"], p.selected ? '#666' : '#afafaf'));
const ItemIcon = (0, _styledComponents.default)(_SVGIcon.default).withConfig({
  displayName: "ActionsMenu__ItemIcon",
  componentId: "sc-5ewbei-4"
})(["margin-right:8px;svg{padding:6px;}"]);

const Separator = _styledComponents.default.div.withConfig({
  displayName: "ActionsMenu__Separator",
  componentId: "sc-5ewbei-5"
})(["border-bottom:1px solid #dfdfdf;margin:8px 0;"]);

const ActionsMenu = ({
  className,
  items,
  width = 256,
  onMenuSelect
}) => {
  const [show, setShow] = (0, _react.useState)(false);
  const [top, setTop] = (0, _react.useState)(0);
  const [left, setLeft] = (0, _react.useState)(0);
  const contentRef = (0, _react.useRef)(null);

  const calculatePos = () => {
    const rect = contentRef.current.getBoundingClientRect();
    setTop(rect.top + 32);
    setLeft(rect.right - width);
  };

  (0, _react.useEffect)(() => {
    window.addEventListener('resize', calculatePos);
    return () => {
      window.removeEventListener('resize', calculatePos);
    };
  }, []);
  (0, _react.useEffect)(() => {
    if (show) {
      calculatePos();
    }
  }, [show]);

  const toggleMenu = () => {
    setShow(!show);
  };

  const handleMenuSelect = item => () => {
    if (item.disabled) {
      return;
    }

    toggleMenu();
    onMenuSelect(item.value);
  };

  const portal = /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(MenuItems, {
    top: top,
    left: left,
    width: width,
    show: top !== 0 && left !== 0
  }, items.map((item, idx) => {
    if (item.text === '-') {
      return /*#__PURE__*/_react.default.createElement(Separator, {
        key: idx
      });
    }

    return /*#__PURE__*/_react.default.createElement(Item, {
      key: idx,
      disabled: item.disabled,
      title: item.title,
      color: item.color,
      onClick: handleMenuSelect(item)
    }, item.icon && /*#__PURE__*/_react.default.createElement(ItemIcon, {
      name: item.icon
    }), item.text);
  })), /*#__PURE__*/_react.default.createElement(Background, {
    onClick: toggleMenu
  })), document.body);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(StyledIcon, {
    ref: contentRef,
    selected: show,
    name: "dotsVertical",
    color: "#afafaf",
    onClick: toggleMenu
  }), show && portal);
};

var _default = (0, _styledComponents.default)(ActionsMenu).withConfig({
  displayName: "ActionsMenu",
  componentId: "sc-5ewbei-6"
})(["position:relative;"]);

exports.default = _default;